"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EvaluationReason = exports.DynamicConfig = void 0;
const statsig_js_lite_1 = __importStar(require("statsig-js-lite"));
const fetcher_1 = __importDefault(require("./fetcher"));
const types_1 = require("./types");
const version_1 = require("./version");
var statsig_js_lite_2 = require("statsig-js-lite");
Object.defineProperty(exports, "DynamicConfig", { enumerable: true, get: function () { return statsig_js_lite_2.DynamicConfig; } });
Object.defineProperty(exports, "EvaluationReason", { enumerable: true, get: function () { return statsig_js_lite_2.EvaluationReason; } });
__exportStar(require("./types"), exports);
const DEFAULT_CLIENT_KEY = 'client-default-key';
// the default event logging api is the Atlassian proxy rather than Statsig's domain, to avoid ad blockers
const DEFAULT_EVENT_LOGGING_API = 'https://xp.atlassian.com/v1/';
/**
 * Access the FeatureGates object via the default export.
 * ```ts
 * import FeatureGates from '@atlaskit/feature-gate-js-client';
 * ```
 */
class FeatureGates {
    /**
     * @description
     * This method initializes the client using a network call to fetch the bootstrap values.
     * If the client is inialized with an `analyticsWebClient`, it will send an operational event
     * to GASv3 with the following attributes:
     * - targetApp: the target app of the client
     * - clientVersion: the version of the client
     * - success: whether the initialization was successful
     * - startTime: the time when the initialization started
     * - totalTime: the total time it took to initialize the client
     * - apiKey: the api key used to initialize the client
     * @param clientOptions {ClientOptions}
     * @param identifiers {Identifiers}
     * @param customAttributes {CustomAttributes}
     * @returns {Promise<void>}
     */
    static async initialize(clientOptions, identifiers, customAttributes) {
        if (FeatureGates.initPromise) {
            if (!FeatureGates.shallowEquals(clientOptions, FeatureGates.initOptions)) {
                console.warn('Feature Gates client already initialized with different options. New options were not applied.');
            }
            return FeatureGates.initPromise;
        }
        const startTime = performance.now();
        FeatureGates.initOptions = clientOptions;
        FeatureGates.initPromise = FeatureGates.init(clientOptions, identifiers, customAttributes)
            .then(() => {
            FeatureGates.initCompleted = true;
        })
            .finally(() => {
            const endTime = performance.now();
            const totalTime = endTime - startTime;
            FeatureGates.fireClientEvent(startTime, totalTime, 'initialize', FeatureGates.initCompleted, clientOptions.apiKey);
        });
        return FeatureGates.initPromise;
    }
    static fireClientEvent(startTime, totalTime, action, success, apiKey = undefined) {
        var _a;
        (_a = FeatureGates.initOptions.analyticsWebClient) === null || _a === void 0 ? void 0 : _a.then((analyticsWebClient) => {
            const attributes = Object.assign({ targetApp: FeatureGates.initOptions.targetApp, clientVersion: version_1.CLIENT_VERSION, success,
                startTime,
                totalTime }, (apiKey && { apiKey }));
            analyticsWebClient.sendOperationalEvent({
                action,
                actionSubject: 'featureGatesClient',
                attributes,
                tags: ['measurement'],
                source: '@atlassian/feature-gate-js-client'
            });
        }).catch((err) => {
            if (FeatureGates.initOptions.environment !==
                types_1.FeatureGateEnvironment.Production) {
                console.error('Analytics web client promise did not resolve', err);
            }
        });
    }
    static async initializeFromValues(clientOptions, identifiers, customAttributes, initializeValues = {}) {
        if (FeatureGates.initPromise) {
            if (!FeatureGates.shallowEquals(clientOptions, FeatureGates.initOptions)) {
                console.warn('Feature Gates client already initialized with different options. New options were not applied.');
            }
            return FeatureGates.initPromise;
        }
        const startTime = performance.now();
        FeatureGates.initOptions = clientOptions;
        FeatureGates.initPromise = FeatureGates.initFromValues(clientOptions, identifiers, customAttributes, initializeValues)
            .then(() => {
            FeatureGates.initCompleted = true;
        })
            .finally(() => {
            const endTime = performance.now();
            const totalTime = endTime - startTime;
            FeatureGates.fireClientEvent(startTime, totalTime, 'initializeFromValues', FeatureGates.initCompleted);
        });
        return FeatureGates.initPromise;
    }
    /**
     * This method updates the user using a network call to fetch the new set of values.
     * @param fetchOptions {FetcherOptions}
     * @param identifiers {Identifiers}
     * @param customAttributes {CustomAttributes}
     */
    static async updateUser(fetchOptions, identifiers, customAttributes) {
        const initializeValuesProducer = () => fetcher_1.default.fetchExperimentValues(fetchOptions, identifiers, customAttributes).then(({ experimentValues, customAttributes }) => ({
            experimentValues,
            customAttributesFromFetch: customAttributes
        }));
        await FeatureGates.updateUserUsingInitializeValuesProducer(initializeValuesProducer, identifiers, customAttributes);
    }
    /**
     * This method updates the user given a new set of bootstrap values obtained from one of the server-side SDKs.
     *
     * @param identifiers {Identifiers}
     * @param customAttributes {CustomAttributes}
     * @param initializeValues {Record<string,unknown>}
     */
    static async updateUserWithValues(identifiers, customAttributes, initializeValues = {}) {
        const initializeValuesProducer = () => Promise.resolve({
            experimentValues: initializeValues,
            customAttributesFromFetch: customAttributes
        });
        await FeatureGates.updateUserUsingInitializeValuesProducer(initializeValuesProducer, identifiers, customAttributes);
    }
    static initializeCalled() {
        return FeatureGates.initPromise != null;
    }
    static initializeCompleted() {
        return FeatureGates.initCompleted;
    }
    /**
     * Returns the value for a feature gate. Returns false if there are errors.
     * @param gateName - The name of the feature gate.
     */
    static checkGate(gateName) {
        try {
            return statsig_js_lite_1.default.checkGate(gateName);
        }
        catch (error) {
            // Log the first occurrence of the error
            if (!FeatureGates.hasCheckGateErrorOccurred) {
                console.warn({
                    msg: 'An error has occurred checking the feature gate. Only the first occurrence of this error is logged.',
                    gateName,
                    error
                });
                FeatureGates.hasCheckGateErrorOccurred = true;
            }
            return false;
        }
    }
    /**
     * Returns the entire config for a given experiment.
     *
     * @param {string} experimentName - The name of the experiment
     * @param {Object} options
     * @param {boolean} options.fireExperimentExposure - Whether or not to fire the exposure event for the experiment. Defaults to true. To log an exposure event manually at a later time, use {@link FeatureGates.manuallyLogExperimentExposure} (see [Statsig docs about manually logging exposures](https://docs.statsig.com/client/jsClientSDK#manual-exposures-)).
     * @returns The config for an experiment
     * @example
     * ```ts
     * const experimentConfig = FeatureGates.getExperiment('example-experiment-name');
     * const backgroundColor: string = experimentConfig.get('backgroundColor', 'yellow');
     * ```
     */
    static getExperiment(experimentName, options = {}) {
        try {
            const { fireExperimentExposure = true } = options;
            const evalMethod = fireExperimentExposure
                ? statsig_js_lite_1.default.getExperiment.bind(statsig_js_lite_1.default)
                : statsig_js_lite_1.default.getExperimentWithExposureLoggingDisabled.bind(statsig_js_lite_1.default);
            return evalMethod(experimentName);
        }
        catch (error) {
            // Log the first occurrence of the error
            if (!FeatureGates.hasGetExperimentErrorOccurred) {
                console.warn({
                    msg: 'An error has occurred getting the experiment. Only the first occurrence of this error is logged.',
                    experimentName,
                    error
                });
                FeatureGates.hasGetExperimentErrorOccurred = true;
            }
            // Return a default value
            return new statsig_js_lite_1.DynamicConfig(experimentName, {}, '', {
                time: Date.now(),
                reason: statsig_js_lite_1.EvaluationReason.Error
            });
        }
    }
    /**
     * Returns the value of a given parameter in an experiment config.
     *
     * @template T
     * @param {string} experimentName - The name of the experiment
     * @param {string} parameterName - The name of the parameter to fetch from the experiment config
     * @param {T} defaultValue - The value to serve if the experiment or parameter do not exist, or if the returned value does not match the expected type.
     * @param {Object} options
     * @param {boolean} options.fireExperimentExposure - Whether or not to fire the exposure event for the experiment. Defaults to true. To log an exposure event manually at a later time, use {@link FeatureGates.manuallyLogExperimentExposure} (see [Statsig docs about manually logging exposures](https://docs.statsig.com/client/jsClientSDK#manual-exposures-))
     * @param {function} options.typeGuard - A function that asserts that the return value has the expected type. If this function returns false, then the default value will be returned instead. This can be set to protect your code from unexpected values being set remotely. By default, this will be done by asserting that the default value and value are the same primitive type.
     * @returns The value of the parameter if the experiment and parameter both exist, otherwise the default value.
     * @example
     ``` ts
     type ValidColor = 'blue' | 'red' | 'yellow';
     type ValidColorTypeCheck = (value: unknown) => value is ValidColor;

     const isValidColor: ValidColorTypeCheck =
        (value: unknown) => typeof value === 'string' && ['blue', 'red', 'yellow'].includes(value);

     const buttonColor: ValidColor = FeatureGates.getExperimentValue(
        'example-experiment-name',
        'backgroundColor',
        'yellow',
        {
            typeGuard: isValidColor
        }
     );
     ```
    */
    static getExperimentValue(experimentName, parameterName, defaultValue, options = {}) {
        const experiment = FeatureGates.getExperiment(experimentName, options);
        try {
            const { typeGuard } = options;
            return experiment.get(parameterName, defaultValue, typeGuard);
        }
        catch (error) {
            // Log the first occurrence of the error
            if (!FeatureGates.hasGetExperimentValueErrorOccurred) {
                console.warn({
                    msg: 'An error has occurred getting the experiment value. Only the first occurrence of this error is logged.',
                    experimentName,
                    defaultValue,
                    options,
                    error
                });
                FeatureGates.hasGetExperimentValueErrorOccurred = true;
            }
            return defaultValue;
        }
    }
    /**
     * Manually log an experiment exposure (see [Statsig docs about manually logging exposures](https://docs.statsig.com/client/jsClientSDK#manual-exposures-)).
     * This is useful if you have evaluated an experiment earlier via {@link FeatureGates.getExperimentValue} or
     * {@link FeatureGates.getExperiment} where <code>options.fireExperimentExposure</code> is false.
     * @param experimentName
     */
    static manuallyLogExperimentExposure(experimentName) {
        statsig_js_lite_1.default.manuallyLogExperimentExposure(experimentName);
    }
    static shutdownStatsig() {
        statsig_js_lite_1.default.shutdown();
    }
    /**
     * Adds a new override for the given gate.
     *
     * This method is additive, meaning you can call it multiple times with different gate names to build
     * your full set of overrides.
     *
     * Overrides are persisted to the `STATSIG_JS_LITE_LOCAL_OVERRIDES` key in localStorage, so they will
     * continue to affect every client that is initialized on the same domain after this method is called.
     * If you are using this API for testing purposes, you should call ${@link FeatureGates.clearGateOverride} after
     * your tests are completed to remove this localStorage entry.
     *
     * @param {string} gateName
     * @param {boolean} value
     */
    static overrideGate(gateName, value) {
        statsig_js_lite_1.default.overrideGate(gateName, value);
    }
    /**
     * Removes any overrides that have been set for the given gate.
     * @param {string} gateName
     */
    static clearGateOverride(gateName) {
        statsig_js_lite_1.default.overrideGate(gateName, null);
    }
    /**
     * Adds a new override for the given config (or experiment).
     *
     * This method is additive, meaning you can call it multiple times with different experiment names to build
     * your full set of overrides.
     *
     * Overrides are persisted to the `STATSIG_JS_LITE_LOCAL_OVERRIDES` key in localStorage, so they will
     * continue to affect every client that is initialized on the same domain after this method is called.
     * If you are using this API for testing purposes, you should call ${@link FeatureGates.clearConfigOverride} after
     * your tests are completed to remove this localStorage entry.
     *
     * @param {string} experimentName
     * @param {object} values
     */
    static overrideConfig(experimentName, values) {
        statsig_js_lite_1.default.overrideConfig(experimentName, values);
    }
    /**
     * Removes any overrides that have been set for the given experiment.
     * @param {string} experimentName
     */
    static clearConfigOverride(experimentName) {
        statsig_js_lite_1.default.overrideConfig(experimentName, null);
    }
    /**
     * Set overrides for gates, experiments and layers in batch.
     *
     * Note that these overrides are **not** additive and will completely replace any that have been added
     * via prior calls to {@link FeatureGates.overrideConfig} or {@link FeatureGates.overrideGate}.
     *
     * Overrides are persisted to the `STATSIG_JS_LITE_LOCAL_OVERRIDES` key in localStorage, so they will
     * continue to affect every client that is initialized on the same domain after this method is called.
     * If you are using this API for testing purposes, you should call ${@link FeatureGates.clearAllOverrides} after
     * your tests are completed to remove this localStorage entry.
     *
     * @param {object} overrides
     */
    static setOverrides(overrides) {
        statsig_js_lite_1.default.setOverrides(Object.assign({ gates: {}, configs: {}, layers: {} }, overrides));
    }
    /**
     * Clears overrides for all gates, configs (including experiments) and layers.
     */
    static clearAllOverrides() {
        statsig_js_lite_1.default.setOverrides(null);
    }
    /**
     * Returns whether the given identifiers and customAttributes align with the current
     * set that is being used by the client.
     *
     * If this method returns false, then the {@link FeatureGates.updateUser} or {@link FeatureGates.updateUserWithValues}
     * methods can be used to re-align these values.
     *
     * @param identifiers
     * @param customAttributes
     * @returns a flag indicating whether the clients current configuration aligns with the given values
     */
    static isCurrentUser(identifiers, customAttributes) {
        return (FeatureGates.shallowEquals(FeatureGates.currentIdentifiers, identifiers) &&
            FeatureGates.shallowEquals(FeatureGates.currentAttributes, customAttributes));
    }
    /**
     * This method initializes the client using a network call to fetch the bootstrap values for the given user.
     *
     * @param clientOptions
     * @param identifiers
     * @param customAttributes
     * @private
     */
    static async init(clientOptions, identifiers, customAttributes) {
        const fromValuesClientOptions = Object.assign(Object.assign({}, clientOptions), { disableCurrentPageLogging: true });
        let experimentValues;
        let customAttributesFromResult;
        if (clientOptions.localMode) {
            console.info(`Initialising Statsig client in local mode without values`);
            await FeatureGates.initFromValues(fromValuesClientOptions, identifiers, customAttributes);
            return;
        }
        try {
            // If client sdk key fetch fails, an error would be thrown and handled instead of waiting for the experiment
            // values request to be settled, and it will fall back to use default values.
            const clientSdkKeyPromise = fetcher_1.default.fetchClientSdk(clientOptions).then((value) => (fromValuesClientOptions.sdkKey = value.clientSdkKey));
            const experimentValuesPromise = fetcher_1.default.fetchExperimentValues(clientOptions, identifiers, customAttributes);
            // Only wait for the experiment values request to finish and try to initialise the client with experiment
            // values if both requests are successful. Else an error would be thrown and handled by the catch
            const [, experimentValuesResult] = await Promise.all([
                clientSdkKeyPromise,
                experimentValuesPromise
            ]);
            experimentValues = experimentValuesResult.experimentValues;
            customAttributesFromResult =
                experimentValuesResult.customAttributes;
        }
        catch (error) {
            if (error instanceof Error) {
                console.error(`Error occurred when trying to fetch the Feature Gates client values, error: ${error === null || error === void 0 ? void 0 : error.message}`);
            }
            console.warn(`Initialising Statsig client without values`);
            await FeatureGates.initFromValues(fromValuesClientOptions, identifiers, customAttributes);
            throw error;
        }
        await this.initFromValues(fromValuesClientOptions, identifiers, customAttributesFromResult, experimentValues);
    }
    /**
     * This method initializes the client using a set of boostrap values obtained from one of the server-side SDKs.
     *
     * @param clientOptions
     * @param identifiers
     * @param customAttributes
     * @param initializeValues
     * @private
     */
    static async initFromValues(clientOptions, identifiers, customAttributes, initializeValues = {}) {
        const user = this.toStatsigUser(identifiers, customAttributes);
        FeatureGates.currentIdentifiers = identifiers;
        FeatureGates.currentAttributes = customAttributes;
        if (!clientOptions.sdkKey) {
            clientOptions.sdkKey = DEFAULT_CLIENT_KEY;
        }
        if (!clientOptions.eventLoggingApi) {
            clientOptions.eventLoggingApi = DEFAULT_EVENT_LOGGING_API;
        }
        const { sdkKey } = clientOptions;
        const statsigOptions = this.toStatsigOptions(clientOptions, initializeValues);
        try {
            await statsig_js_lite_1.default.initialize(sdkKey, user, statsigOptions);
        }
        catch (error) {
            if (error instanceof Error) {
                console.error(`Error occurred when trying to initialise the Statsig client, error: ${error === null || error === void 0 ? void 0 : error.message}`);
            }
            console.warn(`Initialising Statsig client with default sdk key and without values`);
            await statsig_js_lite_1.default.initialize(DEFAULT_CLIENT_KEY, user, Object.assign(Object.assign({}, statsigOptions), { initializeValues: {} }));
            throw error;
        }
    }
    /**
     * This method creates an instance of StatsigUser from the given set of identifiers and attributes.
     *
     * @param identifiers
     * @param customAttributes
     * @private
     */
    static toStatsigUser(identifiers, customAttributes) {
        const user = {
            customIDs: identifiers,
            custom: customAttributes
        };
        if (identifiers.atlassianAccountId) {
            user.userID = identifiers.atlassianAccountId;
        }
        return user;
    }
    /**
     * This method updates the user for this client with the bootstrap values returned from a given Promise.
     * It uses the customAttributes from fetching experiment values to update the Statsig user but
     * uses the customAttributes from given input to check if the user has changed.
     *
     * @param {Identifiers} identifiers
     * @param {CustomAttributes} customAttributes
     * @param {Promise<InitializeValues>} getInitializeValues
     * @private
     */
    static async updateUserUsingInitializeValuesProducer(getInitializeValues, identifiers, customAttributes) {
        if (!FeatureGates.initPromise) {
            throw new Error('The FeatureGates client must be initialized before you can update the user.');
        }
        // If the user isn't changing at all, then exit immediately
        if (FeatureGates.isCurrentUser(identifiers, customAttributes)) {
            return FeatureGates.initPromise;
        }
        // Wait for the current initialize/update to finish
        const originalInitPromise = FeatureGates.initPromise;
        try {
            await FeatureGates.initPromise;
        }
        catch (err) {
            // Proceed with the user update even if the init failed, since this update
            // may put the client back into a valid state.
        }
        const initializeValuesPromise = getInitializeValues();
        const updateUserPromise = FeatureGates.updateStatsigClientUser(initializeValuesPromise, identifiers, customAttributes);
        // We replace the init promise here since we are essentially re-initializing the client at this point.
        // Any subsequent calls to await FeatureGates.initialize() or FeatureGates.updateUser() will now also await this user update.
        FeatureGates.initPromise = updateUserPromise.catch(() => {
            // If the update failed then it changed nothing, so revert back to the original promise.
            FeatureGates.initPromise = originalInitPromise;
        });
        return updateUserPromise;
    }
    /**
     * This method updates the user on the nested Statsig client
     *
     * @param identifiers
     * @param customAttributes
     * @param initializeValuesPromise
     * @private
     */
    static async updateStatsigClientUser(initializeValuesPromise, identifiers, customAttributes) {
        var _a, _b;
        let initializeValues, user;
        try {
            initializeValues = await initializeValuesPromise;
            user = FeatureGates.toStatsigUser(identifiers, initializeValues.customAttributesFromFetch);
        }
        catch (err) {
            // Make sure the updateUserCompletionCallback is called for any errors in our custom code.
            // This is not necessary for the updateUserWithValues call, because the Statsig client will already invoke the callback itself.
            const errMsg = err instanceof Error ? err.message : JSON.stringify(err);
            (_b = (_a = FeatureGates.initOptions).updateUserCompletionCallback) === null || _b === void 0 ? void 0 : _b.call(_a, false, errMsg);
            throw err;
        }
        const success = statsig_js_lite_1.default.updateUserWithValues(user, initializeValues.experimentValues);
        if (success) {
            FeatureGates.currentIdentifiers = identifiers;
            FeatureGates.currentAttributes = customAttributes;
        }
        else {
            throw new Error('Failed to update user. An unexpected error occured.');
        }
    }
    /**
     * This method transforms the options given by the user into the format accepted by the Statsig client.
     *
     * @param options
     * @param {Record<string, unknown>} initializeValues
     * @private
     */
    static toStatsigOptions(options, initializeValues) {
        const { 
        // De-structured to remove from restClientOptions
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        sdkKey, 
        // De-structured to remove from restClientOptions
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        updateUserCompletionCallback } = options, restClientOptions = __rest(options, ["sdkKey", "updateUserCompletionCallback"]);
        return Object.assign(Object.assign(Object.assign({}, restClientOptions), { initializeValues, environment: {
                tier: options.environment
            }, disableCurrentPageLogging: true }), (options.updateUserCompletionCallback && {
            updateUserCompletionCallback: FeatureGates.toStatsigUpdateUserCompletionCallback(options.updateUserCompletionCallback)
        }));
    }
    /**
     * This method transforms an UpdateUserCompletionCallback in our own format into the format accepted by the Statsig client.
     *
     * @param callback
     * @private
     */
    static toStatsigUpdateUserCompletionCallback(callback) {
        /**
         * The duration passed to the callback indicates how long the update took, but it is deceptive since it only times the
         * Statsig code and doesn't account for all of the extra custom work we do to obtain the bootstrap values.
         * As a result, we just suppress this parameter in our own callback rather than trying to keep it accurate.
         */
        return (_duration, success, message) => {
            callback(success, message);
        };
    }
    static shallowEquals(objectA, objectB) {
        if (!objectA && !objectB) {
            return true;
        }
        if (!objectA || !objectB) {
            return false;
        }
        const aEntries = Object.entries(objectA);
        const bEntries = Object.entries(objectB);
        if (aEntries.length !== bEntries.length) {
            return false;
        }
        const ascendingKeyOrder = ([key1], [key2]) => key1.localeCompare(key2);
        aEntries.sort(ascendingKeyOrder);
        bEntries.sort(ascendingKeyOrder);
        for (let i = 0; i < aEntries.length; i++) {
            const [, aValue] = aEntries[i];
            const [, bValue] = bEntries[i];
            if (aValue !== bValue) {
                return false;
            }
        }
        return true;
    }
    /**
     * @returns string version of the current package in semver style.
     */
    static getPackageVersion() {
        return version_1.CLIENT_VERSION;
    }
}
FeatureGates.initPromise = null;
FeatureGates.initCompleted = false;
FeatureGates.hasGetExperimentErrorOccurred = false;
FeatureGates.hasGetExperimentValueErrorOccurred = false;
FeatureGates.hasCheckGateErrorOccurred = false;
let boundFGJS = FeatureGates;
// This makes it possible to get a reference to the FeatureGates client at runtime.
// This is important for overriding values in Cyprus tests, as there needs to be a
// way to get the exact instance for a window in order to mock some of its methods.
if (typeof window !== 'undefined') {
    if (window.__FEATUREGATES_JS__ === undefined) {
        window.__FEATUREGATES_JS__ = FeatureGates;
    }
    else {
        boundFGJS = window.__FEATUREGATES_JS__;
        const boundVersion = (boundFGJS === null || boundFGJS === void 0 ? void 0 : boundFGJS.getPackageVersion()) || '4.10.0 or earlier';
        const message = `Multiple versions of FeatureGateClients found on the current page.
        The currently bound version is ${boundVersion} when module version ${version_1.CLIENT_VERSION} was loading.`;
        console.warn(message);
    }
}
/**
 * @property {FeatureGates} FeatureGate default export
 */
exports.default = boundFGJS;
